(() => {
  // let timeout = false;
  // let delay = 250;
  const backdrop = document.querySelector(".rebuy-backdrop");

  window.Rebuy7Q81 = {
    openBackdrop: function () {
      backdrop.style.display = "block";
      backdrop.classList.add("open");
      document.querySelector("body").style.overflow = "hidden";
    },
    closeBackdrop: function () {
      backdrop.style.display = "none";
      document.body.classList.remove("quick-add-open");
      backdrop.classList.remove("open");
      document.querySelector("body").style.overflow = "auto";
    },
  };

  // function updateBackdrop() {
  // 	if (window.innerWidth < 769) {
  // 		if(document.body.classList.contains('quick-add-open')) {
  // 			openBackdrop();
  // 		}
  // 	} else {
  // 		closeBackdrop();
  // 	}
  // }

  // window.addEventListener('resize', () => {
  // 	clearTimeout(timeout);
  // 	timeout = setTimeout(updateBackdrop, delay);
  // });

  backdrop.addEventListener("click", (event) => {
    var elem = document.querySelector(".open-quick-add .rebuy-hover-options");
    if (elem && !elem.contains(event.target)) {
      let close = elem.querySelector(".btn-close");
      close.click();
    }
  });
})();
